module.exports = __webpack_public_path__ + "static/media/iconDistribution.2094893b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/iconDistribution.svg
// module id = 436
// module chunks = 0